export const getBrowserLanguage = (): string | null => {
	const savedLanguage = localStorage.getItem('i18nextLng');
	if (savedLanguage) {
		return savedLanguage;
	}
	const browserLanguage = navigator.language.split('-')[0]; // np. 'cs-CZ' -> 'cs'
	return browserLanguage;
};
